import { useKeyboardHeight } from '@/lib/keyboard'
import { cn } from '@/lib/utils'

interface AppLayoutProps {
  topBar?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  className?: string
  noPadding?: boolean
  wrapperClassName?: string
  wrapperStyle?: React.CSSProperties
}

export function AppLayout({
  topBar,
  children,
  footer,
  className,
  noPadding,
  wrapperClassName,
  wrapperStyle,
}: AppLayoutProps) {
  const keyboardHeight = useKeyboardHeight()

  return (
    <div
      className={cn(
        'flex flex-col h-full bg-surface-brand-L0 transition-[padding-bottom] duration-300 ease-out',
        wrapperClassName,
      )}
      // Keyboard.resize is "none": the webview keeps its size and the keyboard
      // overlays it, so shrink the layout by the keyboard height to push the
      // content (and any footer) up above it.
      style={{ ...wrapperStyle, paddingBottom: keyboardHeight || undefined }}
    >
      {topBar}
      <div
        className={cn(
          'flex-1 flex flex-col gap-4 overflow-y-auto overscroll-contain min-h-0 relative',
          !noPadding && 'px-gutter',
          className,
        )}
      >
        {children}
      </div>
      {footer}
    </div>
  )
}
